import { ServerExportStatusBanner } from 'components/server-export-status-banner';
import type { ServerExportStatus } from 'lib/hooks/useServerExport';
import styles from './spatial-export-banner.module.scss';

interface SpatialExportBannerProps {
  /** The surface's async export status. */
  status: ServerExportStatus;
  /** Dismisses the banner (resets the export status to idle). */
  onDismiss: () => void;
}

/**
 * The floating async-status banner shared by every spatial-export surface (Map Query, Areas, Type
 * Curves): it pins {@link ServerExportStatusBanner} top-right so progress / success / error feedback
 * never disturbs the toolbar the Export button sits in. Renders nothing while idle, so callers can drop
 * it in unconditionally.
 *
 * @param {SpatialExportBannerProps} props - The async status and the dismiss handler.
 * @return {JSX.Element | null} The floating banner, or null while idle.
 */
export function SpatialExportBanner({
  status,
  onDismiss,
}: SpatialExportBannerProps) {
  if (status.status === 'idle') return null;

  return (
    <div className={styles.bannerWrap}>
      <ServerExportStatusBanner status={status} onDismiss={onDismiss} />
    </div>
  );
}
